export default function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}



// WEBPACK FOOTER //
// ./src/refer/utils/getDisplayName.js